//import { JVSunEditor } from "../../shared/JVSuneditor";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import { JVInput } from "../../shared/JVInput";
import { useEffect, useRef, useState } from "react";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { useForm } from "react-hook-form";
// import * as yup from "yup";
import { ISignatureMast } from "../../models/SignatureMast";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Fetch } from "../../shared/Fetch";
import { IPermissionProps } from "../../models/Login";
import { Editor } from 'primereact/editor';

// const schema = yup.object({
//     disclaimer: yup.string().required("disclaimer is required")
// });

export const SignatureMast = (permissions: IPermissionProps) => {
    const [shortSignature, setShortSignature] = useState("");
    const [signature, setSignature] = useState("");
    const [loading, setLoading] = useState(false);
    const toast = useRef<any>(null);

    // const { control, handleSubmit, formState: { errors }, setValue } = useForm<ISignatureMast>({
    //     resolver: yupResolver(schema),
    //     defaultValues: {}
    // });

    const loadSignature = async () => {
        setLoading(true);
        const response = await Fetch("Signature_Mast", "GET", null, null, toast);
        if (response) {
            const data: ISignatureMast = await response.json();
            // if (data.disclaimer) setValue("disclaimer", data.disclaimer);
            if (data.signature) setSignature(data.signature);
            if (data.short_Signature) setShortSignature(data.short_Signature);
            setLoading(false);
        } else setLoading(false);
    }

    useEffect(() => {
        loadSignature();
    }, []);

    const saveToDb = async () => {
        const fbody = { short_Signature: shortSignature, signature: signature };
        // fbody.short_Signature = shortSignature;
        // fbody.signature = signature;

        const response = await Fetch("Signature_Mast", "POST", fbody, null, toast);
        if (response) {
            const message = await response.text();
            toast.current.show({ severity: 'success', detail: message, life: 3000 });
        }
    }

    function onSubmit() {
        if (shortSignature.length < 1) toast.current.show({ severity: 'error', detail: "Short Signature is Required.", life: 3000 });
        else if (signature.length < 1) toast.current.show({ severity: 'error', detail: "Full Signature is Required.", life: 3000 });
        else saveToDb();
    }

    return (
        <div className="p-fluid formgrid grid">
            {/* <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid"> */}
            {/* <JVInput column={1} label="Disclaimer" control={control} name="disclaimer" error={errors.disclaimer?.message} /> */}
            <div className="col-12 md:col-12 md:col-6 mb-3">
                <label htmlFor="short_Signature">Short Signature</label>
                <Editor value={shortSignature} onTextChange={(e) => setShortSignature(e.htmlValue || "")} style={{ height: '320px' }} />
                {/* <CKEditor editor={ClassicEditor} data={shortSignature} onChange={(event, editor) => { setShortSignature(editor.getData()); }} /> */}
                {/* <JVSunEditor value={shortSignature} handleChange={setShortSignature}/> */}
            </div>
            <div className="col-12 md:col-12 md:col-6">
                <label htmlFor="signature">Full Signature</label>
                <Editor value={signature} onTextChange={(e) => setSignature(e.htmlValue || "")} style={{ height: '320px' }} />
                {/* <CKEditor editor={ClassicEditor} data={signature} onChange={(event, editor) => { setSignature(editor.getData()); }} /> */}
                {/* <JVSunEditor value={signature} handleChange={setSignature}/> */}
            </div>
            <div className="col-12 md:col-12 mt-3">
                <Button onClick={onSubmit} loading={loading} className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
            </div>
            {/* </form> */}
            <Toast ref={toast} />
        </div>
    );
}